import { TabAction } from '..';
import { TabBase } from '../types';

const PillTabBarItem = ({ label, selected, onClick }: TabBase) => {
  return (
    <TabAction
      className="relative flex w-full flex-col items-center justify-end outline-none md:w-max"
      onClick={onClick}>
      <span
        className={`px-sm py-xs w-full rounded-[34px]  ${
          selected ? 'bg-bg_primary text-fg_primary_inverse' : 'text-fg_secondary'
        }`}>
        {label}
      </span>
    </TabAction>
  );
};

export default PillTabBarItem;
